import { useSrpContext } from '@/src/contexts'

import RouteGuide from './routeGuide'

const RouteGuideWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()

    const routeFacts = sections?.routeFacts
    if (!routeFacts?.facts?.length) return null

    return (
        <RouteGuide
            title={routeFacts.title}
            summary={routeFacts.summary}
            facts={routeFacts.facts}
        />
    )
}

export default RouteGuideWrapper
